import { NgModule } from '@angular/core';
import { OpportunityComponent } from './opportunity.component';
import { OpportunityRoutingModule } from './opportunity.routing.module';

@NgModule({
  declarations: [OpportunityComponent],
  imports: [OpportunityRoutingModule],
})
export class OpportunityModule {}
